import { render } from "./CcmpProTemplates.vue?vue&type=template&id=47a68e77&bindings={\"lessons\":\"options\",\"ccmpProTitles\":\"options\",\"templateGroups\":\"options\",\"extractLinksFromMarkdown\":\"options\"}"
import script from "./CcmpProTemplates.vue?vue&type=script&lang=js"
export * from "./CcmpProTemplates.vue?vue&type=script&lang=js"

import "./CcmpProTemplates.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script